module.exports = __webpack_public_path__ + "img/ic_next2.51c616a0.svg";